import { BasicMenuItemOption } from 'ui/menu';

import { ListType } from 'modules/domains';
import { useTranslation } from 'modules/domains/list';

import { LIST_TYPE_MENU_OPTION_ID_PREFIX } from '../constants';

export const useListTypeMenuOptions = (): BasicMenuItemOption[] => {
  const { t } = useTranslation();
  return Object.values(ListType).map((listType) => ({
    id: `${LIST_TYPE_MENU_OPTION_ID_PREFIX}${listType}`,
    label: t(`indexPage.listTypes.${listType}`) ?? listType,
  }));
};
